export type AtlasManualDisplayChoiceId = "simple" | "photos" | "compact";

export type AtlasManualCardChoiceId = "initials" | "role" | "team";

export type AtlasManualLayoutChoiceId = "manual" | "tree" | "rows" | "side";

export const DEFAULT_ATLAS_MANUAL_CARD_ACCENT = "#10B981";

export const ATLAS_MANUAL_CARD_ACCENT_PRESETS = [
  DEFAULT_ATLAS_MANUAL_CARD_ACCENT,
  "#2563EB",
  "#0EA5E9",
  "#F59E0B",
  "#EF4444",
  "#334155",
] as const;

export function resolveOrgCardAccent(
  value: string | null | undefined,
  fallback: string = DEFAULT_ATLAS_MANUAL_CARD_ACCENT,
): string {
  const normalized = typeof value === "string" ? value.trim() : "";
  if (/^#[0-9a-f]{6}$/i.test(normalized)) return normalized;
  return fallback;
}
